import React, { useRef } from 'react';
import ImageOverlayCard from './ImageOverlayCard';
import AssetProgressionLogo from '../../assets/Workwithus/AssetProgression.png';
import PropertyTransactionLogo from '../../assets/Workwithus/PropertyTransaction.png';
import PortfolioLogo from '../../assets/Workwithus/PortfolioManagement.png';
import InvestmentLogo from '../../assets/Workwithus/PropertyInvestment.png';
import '../../styles/WorkWithUs.css';
import useDragToScroll from '../../hooks/useDragToScroll';

const reasonCards = [
  {
    logo: AssetProgressionLogo,
    title: 'Asset Progression',
    description:
      'Strategically upgrade and leverage existing properties to build a strong property portfolio and generate higher returns.',
  },
  {
    logo: PropertyTransactionLogo,
    title: 'Property Transaction',
    description:
      'We help buy, sell, and lease properties — handling market analysis, negotiation, and all legal and financial steps.',
  },
  {
    logo: PortfolioLogo,
    title: 'Portfolio Management',
    description:
      'Manage your collection of real estate investments to meet long-term financial goals with strategic oversight.',
  },
  {
    logo: InvestmentLogo,
    title: 'Property Investment',
    description:
      'Identify real estate opportunities to grow capital and earn passive income through smart, data-backed decisions.',
  },
];

const WhyWorkWithUsSection = () => {
  const sliderRef = useRef();
  useDragToScroll(sliderRef);

  return (
    <section className="innerSection">
      <h2>Why Choose JS Property?</h2>
      <div className="cardSlider" ref={sliderRef}>
        {reasonCards.map((card, index) => (
          <ImageOverlayCard
            key={index}
            logo={card.logo}
            title={card.title}
            description={card.description}
          />
        ))}
      </div>
    </section>
  );
};

export default WhyWorkWithUsSection;
